(function referenceToolbarActions(global) {
  "use strict";

  /**
   * Навешивает контекстное меню фильтра по текущему периоду.
   *
   * @function Core.toolBars.main#reateCurrentPeriodFilterMenu
   * @param {WebAccess.components.wrappers.toolBar.ToolBarButton} btn btn Кнопка тулбара, для которой навешивается контекстное меню фильтрации.
   * @param {function} onPeriodSet Callback-функция, выполняемая при установке периода.
   * @param {string} [opt_placementContext] Контекст, в рамках которого происходит установка фильтрации.
   * @param {boolean} [opt_needDisableChangeCurrentPeriod=false] Флаг запрета на отключение текущего периода.
   * @since 5.0.0.1904
   * @return {boolean} True - если контекстное меню фильтра добавлено успешно, иначе False.
   */
  global.createCurrentPeriodFilterMenu = function (btn, onPeriodSet, opt_placementContext, opt_needDisableChangeCurrentPeriod) {
    var items = [];
    var needDisableChangeCurrentPeriod = opt_needDisableChangeCurrentPeriod || false;
    // в этот метод в качестве this приходил Window, когда кнопки не было на тулбаре вкладки (например, на вкладке "карточка".
    // Возможно, где-то в другом месте стоит проверять, если ли кнопка в тулбаре, перед вызовом этой функции.
    // TODO: фактически, у нас вызывается onInit у кнопки, которой нет (как минимуму, в тулбаре нереактивной вкладки). Стоит пересмотреть поведение.
    if (btn.className !== 'ReactToolBarButton' && btn.className !== 'ToolBarButton') {
      return false;
    }
    var jButtonSelector = format('div[name={0}]', btn.name);
    var jButton = $(jButtonSelector);
    if (!jButton.length) {
      return false;
    }
    
    var isCurrentPeriodRequired = $("#toolbar_container")
      .closest('span')
      .data('currentperiodisrequired') === 'True';
    var isSelected = btn.isSelected() || isCurrentPeriodRequired;
    if (isCurrentPeriodRequired) {
      jButton.addClass('selected');
    }
    items.push({
      name: 'toggle',
      label: L('CURRENT_PERIOD_TOGGLE'),
      tooltip: L('SET_INTERVAL_ACTION_HINT'),
      icon: 'filterPeriod-16',
      selected: isSelected,
      onCreate: function (item) {
        item.selected = btn.isSelected() || isCurrentPeriodRequired;
      },
      disabled: isCurrentPeriodRequired
    });
    items.push({
      name: 'change',
      label: L('CHANGE_CURRENT_PERIOD'),
      tooltip: L('CURRENT_PERIOD_ACTION_HINT'),
      icon: 'calendar-16',
      disabled: needDisableChangeCurrentPeriod
    });
    var settings = {
      shiftY: 37
    };
    $.extend(settings, selectToolbarBtnOnShowContextMenu(jButton));
    var cm = new WA.components.menus.BaseContextMenu(jButtonSelector, items, settings);
    cm.render();
    cm.bind("itemSelect", function (item) {
      switch (item.name) {
        case 'toggle':
          ToggleCurrentPeriod(btn, onPeriodSet, opt_placementContext);
          break;
        case 'change':
          SetCurrentPeriod(onPeriodSet);
          break;
      }
    });
    return true;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * @function SetCurrentPeriod - действие по кнопке "Изменить период".
   * @param {function} onPeriodSet - callback установки текущего периода.
   */
  function SetCurrentPeriod(onPeriodSet) {

    // Тип периода, определяет, на какой момент времени относительно текущего накладывается период.
    var CURRENT_PERIOD_TYPE = {
      CURRENT: '0',
      PREVIOUS: '1',
      SLIDING: '2',
      CUSTOM: '3'
    };

    // Длина периода, определяет протяжённость действия текущего периода.
    var CURRENT_PERIOD_LENGTH = {
      MONTH: '0',
      QUARTER: '1',
      YEAR: '2',
      CUSTOM: '3'
    };

    var dialog = (new WA.CMP.dialogs.BaseDialog())
      .showCancelButton()
      .setSpinner()
      .show();

    // Форма текущего периода.
    var form = {

      // Измененность формы
      _isChanged: false,

      // Реквизиты формы.
      requisites: {},

      // Рендеринг HTML-кода формы.
      renderAsync: function () {
        var currentPick = new WebAccess.components.forms.requisites.Pick();
        var currentPickData = {
          id: 'currentPeriod_currentPick',
          uniqueID: 'currentPeriod_currentPick',
          values: $.toJSON([
            [CURRENT_PERIOD_LENGTH.MONTH, L('MONTH'), L('MONTH')],
            [CURRENT_PERIOD_LENGTH.QUARTER, L('QUARTER'), L('QUARTER')],
            [CURRENT_PERIOD_LENGTH.YEAR, L('YEAR'), L('YEAR')]
          ]),
          selectedValue: L('MONTH'),
          selectedKey: CURRENT_PERIOD_LENGTH.MONTH,
          styleClass: '',
          isReadOnly: true
        };

        var previousPick = new WebAccess.components.forms.requisites.Pick();
        var previousPickData = {
          id: 'currentPeriod_previousPick',
          uniqueID: 'currentPeriod_previousPick',
          values: $.toJSON([
            [CURRENT_PERIOD_LENGTH.MONTH, L('MONTH'), L('MONTH')],
            [CURRENT_PERIOD_LENGTH.QUARTER, L('QUARTER'), L('QUARTER')],
            [CURRENT_PERIOD_LENGTH.YEAR, L('YEAR'), L('YEAR')]
          ]),
          selectedValue: L('MONTH'),
          selectedKey: CURRENT_PERIOD_LENGTH.MONTH,
          styleClass: '',
          isReadOnly: true
        };

        var lastDays = $.Deferred();
        var lastDaysHtml = '<input id="currentPeriod_lastDays" class="input w100" value="30"/>';
        lastDays.resolve(lastDaysHtml);

        var beginDateData = {
          id: 'currentPeriod_beginDate',
          value: '',
          showTime: false
        };
        var endDateData = {
          id: 'currentPeriod_endDate',
          value: '',
          showTime: false
        };

        return $.when(
          currentPick.renderAsync(currentPickData),
          previousPick.renderAsync(previousPickData),
          lastDays,
          WA.templates.render('formBuilder/date.compile.html', beginDateData),
          WA.templates.render('formBuilder/date.compile.html', endDateData)
        ).then(function (currentPickHtml, previousPickHtml, lastDaysHtml, beginDateHtml, endDateHtml) {
          return WA.templates.render('components/currentPeriod.compile.html', {
            currentPickLabel: L('CURRENT'),
            currentPickHtml: currentPickHtml,
            previousPickLabel: L('PREVIOUS'),
            previousPickHtml: previousPickHtml,
            lastDaysLabel: L('LAST'),
            lastDaysLabelEnd: L('DAYS'),
            lastDaysHtml: lastDaysHtml,
            periodLabel: L('PERIOD'),
            beginDateLabel: L('FROM'),
            beginDateHtml: beginDateHtml,
            endDateLabel: L('TO'),
            endDateHtml: endDateHtml
          });
        });
      },

      // Инициализация реквизитов.
      init: function (jForm) {
        var me = this;
        me.jForm = jForm;

        jForm.find('input#currentPeriod_lastDays').autoNumeric('init', { mDec: '0', aPad: false });

        me.requisites = {
          'Current': new WebAccess.components.wrappers.form.requisites.Pick('Current', 'currentPeriod_currentPick'),
          'Previous': new WebAccess.components.wrappers.form.requisites.Pick('Previous', 'currentPeriod_previousPick'),
          'LastDays': new WebAccess.components.wrappers.form.requisites.Integer('LastDays', 'currentPeriod_lastDays'),
          'BeginDate': new WebAccess.components.wrappers.form.requisites.Date('BeginDate', 'currentPeriod_beginDate'),
          'EndDate': new WebAccess.components.wrappers.form.requisites.Date('EndDate', 'currentPeriod_endDate')
        };

        // По умолчанию все дизэйблим.
        for (var reqName in me.requisites) {
          me.requisites[reqName].disable();
          me.requisites[reqName].bind('change', function () {
            me._isChanged = true;
          });
        }

        jForm.find('input[name=currentPeriodType]').click(function () {
          me.setType($(this).val());
          me._isChanged = true;
        });
      },

      getIsChanged: function() {
        return this._isChanged;
      },

      // Установить тип текущего периода.
      setType: function (type) {
        var me = this;
        for (var reqName in me.requisites) {
          me.requisites[reqName].disable();
        }

        me.jForm.find('input[name=currentPeriodType]').prop('checked', false);
        me.jForm.find('input[value=' + type + ']').prop('checked', true);

        switch (type) {
          case 'previous':
            me.requisites.Previous.enable();
            break;
          case 'sliding':
            me.requisites.LastDays.enable();
            break;
          case 'custom':
            me.requisites.BeginDate.enable();
            me.requisites.EndDate.enable();
            break;
          case 'current':
          default:
            me.requisites.Current.enable();
            break;
        }
      },

      // Получить тип текущего периода.
      getType: function () {
        return this.jForm.find('input[name=currentPeriodType]').filter(':checked').val();
      },

      // Установить значение реквизита.
      setValue: function (reqName, value) {
        this.requisites[reqName].setValue(value, undefined, false);
      },
      // Получить значение реквизита.
      getValue: function (reqName) {
        return this.requisites[reqName].getValue();
      },
      // Проверка валидности формы.
      isValid: function () {
        return true;
      }

    };

    $.when(form.renderAsync(), WA.SRV.call('/Session.asmx/GetCurrentPeriod')).done(function(html, period) {
      var period = period[0];

      dialog.setTitle(L('CURRENT_PERIOD_SET'));
      dialog.setHtml(html);

      form.init(dialog._jContent);

      // Устанавливаем значения на форме.
      var type = period.PeriodType;
      switch ('' + type) {
      case CURRENT_PERIOD_TYPE.PREVIOUS:
        form.setType('previous');
        form.setValue('Previous', '' + period.PeriodLength);
        break;

      case CURRENT_PERIOD_TYPE.SLIDING:
        form.setType('sliding');
        form.setValue('LastDays', period.PeriodLength);
        break;

      case CURRENT_PERIOD_TYPE.CUSTOM:
        form.setType('custom');
        form.setValue('BeginDate', period.Period.AsString[0]);
        form.setValue('EndDate', period.Period.AsString[1]);
        break;

      case CURRENT_PERIOD_TYPE.CURRENT:
      default:
        form.setType('current');
        form.setValue('Current', '' + period.PeriodLength);
      }
      BindHelpIcoClickOnModalWindow('CurrentPeriod');
    });

    dialog.ok = function () {
      if (form.isValid() === false) return false;

      var type, days, begin, end;
      // Сохраняем текущий период по значениям с формы.
      var formType = form.getType();
      switch (formType) {
        case 'previous':
          type = CURRENT_PERIOD_TYPE.PREVIOUS;
          days = form.getValue('Previous');
          break;
        case 'sliding':
          type = CURRENT_PERIOD_TYPE.SLIDING;
          days = form.getValue('LastDays');
          if ((!days) || (days == '') || (days == '0'))
            days = 1;
          if (days > 10000)
            days = 10000;
          if (days < 1)
            days = 1;
          break;
        case 'custom':
          type = CURRENT_PERIOD_TYPE.CUSTOM;
          begin = form.getValue('BeginDate');
          end = form.getValue('EndDate');
          break;
        case 'current':
        default:
          type = CURRENT_PERIOD_TYPE.CURRENT;
          days = form.getValue('Current');
      };

      // Проверка на измененность формы необходимо для снижения числа запросов,
      // отправляемых на сервер
      if (form.getIsChanged()) {
        var setCurrentPeriodService;
        if (type === CURRENT_PERIOD_TYPE.CUSTOM) {
          setCurrentPeriodService = WA.SRV.call("/Session.asmx/SetCurrentPeriod", {
            PerionBegin: begin,
            PeriodEnd: end
          });
        } else {
          setCurrentPeriodService = WA.SRV.call("/Session.asmx/SetCurrentPeriodByType", {
            CurrentPeriodType: +type,
            CurrentPeriodLength: +days
          });
        }

        setCurrentPeriodService.done(function () {
          if ($.isFunction(onPeriodSet)) {
            // Сбросить выделение
            var grid = Core.grid.reference.grid;
            if (grid) {
              grid.setSelectedRows([]);
            }

            onPeriodSet(dialog);
          } else {
            UnbindBeforeUnload();
            window.location.reload();
          }
          $('html').trigger(PAGE_EVENTS.TOGGLE_PERIOD);
        });
      } else {
        dialog.close();
      }

      return false;
    };
  }

  /**
   * @function ToggleCurrentPeriod - действие по кнопке "Фильтр по периоду"
   * @param {object} btn - кнопка включение/отключения текущего периода.
   * @param {function} onPeriodSet - callback установки текущего периода.
   * @param {string} opt_placementContext - контекст, в рамках которого происходит установка фильтрации.
   */
  function ToggleCurrentPeriod(btn, onPeriodSet, opt_placementContext) {
    var isEnabled;
    if(btn.isSelected()) {
      isEnabled = false;
      btn.unSelect();
    } else {
      isEnabled = true;
      btn.select();
    }

    var location = WA.getLocation();
    CallService("/Session.asmx/EnableCurrentPeriod", {
      Enable: isEnabled,
      Location: location,
      PlacementContext: opt_placementContext || ''
    }, function (res) {
      // Если все сохранилось, то убираем спинер
      HideTopSpinner("", 1);
      if (res.Success) {
        if ($.isFunction(onPeriodSet)) {
          // Сбросить выделение
          var grid = Core.grid.reference.grid;
          if (grid) {
            grid.setSelectedRows([]);
          }

          onPeriodSet();
        }
        $('html').trigger(PAGE_EVENTS.TOGGLE_PERIOD);
      } else {
        WA.CMP.NTF.InlineHint.hideAll();
        WA.CR.inlineHint.showError(res.Error, null, INLINE_HINT_PRIORITY.PRIMARY);
      }
    });
  }

  /**
   * Callback-функция закрытия диалога при установке текущего периода.
   * 
   * @function Core.toolBars.main.onPeriodSetCallback
   * @param {object} dialog - диалог установки текущего периода.
   */
  global.onPeriodSetCallback = function(dialog) {
    if (dialog) {
      dialog.close();
    }
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core.toolBars.main);
